/* lib/api/versions.js — REST-клиент /api/{ttk|kitchen/cards|menus}/<id>/versions/*
 * (порт из frontend/src/lib/api/versions.js, 1:1; только импорт apiFetch → './client.js').
 * Все ответы — {ok, status, data}; кросс-каттинг для VersionsBlock (kind ∈ {ttk,card,menu}).
 * Бэк определяет kind по самому URL (versions.urls смонтированы внутри ttk/kitchen/menu). */

import { apiFetch } from './client.js';

// ── TTK ─────────────────────────────────────────────────────────────────────

// ?include=snapshot — список сразу со снимками (один запрос вместо 1+N detail-добоборов).
export const listTTKVersions = (ttkId) =>
  apiFetch(`/api/ttk/${ttkId}/versions/?include=snapshot`);

export const getTTKVersion = (ttkId, versionNumber) =>
  apiFetch(`/api/ttk/${ttkId}/versions/${versionNumber}/`);

export const restoreTTKVersion = (ttkId, versionNumber) =>
  apiFetch(`/api/ttk/${ttkId}/versions/${versionNumber}/restore/`, {
    method: 'POST',
  });

export const compareTTKVersions = (ttkId, a, b) => {
  const qs = b != null ? `?a=${a}&b=${b}` : `?a=${a}`;
  return apiFetch(`/api/ttk/${ttkId}/versions/compare/${qs}`);
};

// ── IngredientCard ──────────────────────────────────────────────────────────

export const listCardVersions = (cardId) =>
  apiFetch(`/api/kitchen/cards/${cardId}/versions/?include=snapshot`);

export const getCardVersion = (cardId, versionNumber) =>
  apiFetch(`/api/kitchen/cards/${cardId}/versions/${versionNumber}/`);

export const restoreCardVersion = (cardId, versionNumber) =>
  apiFetch(`/api/kitchen/cards/${cardId}/versions/${versionNumber}/restore/`, {
    method: 'POST',
  });

export const compareCardVersions = (cardId, a, b) => {
  const qs = b != null ? `?a=${a}&b=${b}` : `?a=${a}`;
  return apiFetch(`/api/kitchen/cards/${cardId}/versions/compare/${qs}`);
};

// ── Menu ────────────────────────────────────────────────────────────────────

export const listMenuVersions = (menuId) =>
  apiFetch(`/api/menus/${menuId}/versions/?include=snapshot`);

export const getMenuVersion = (menuId, versionNumber) =>
  apiFetch(`/api/menus/${menuId}/versions/${versionNumber}/`);

export const restoreMenuVersion = (menuId, versionNumber) =>
  apiFetch(`/api/menus/${menuId}/versions/${versionNumber}/restore/`, {
    method: 'POST',
  });

export const compareMenuVersions = (menuId, a, b) => {
  const qs = b != null ? `?a=${a}&b=${b}` : `?a=${a}`;
  return apiFetch(`/api/menus/${menuId}/versions/compare/${qs}`);
};
